var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5 0h-12C.675 0 .007.675.007 1.5L0 10.5c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zm0 3l-6 3.75L1.5 3V1.5l6 3.75 6-3.75V3z","fill":"currentColor","fillRule":"evenodd"}));
}

Email.defaultProps = {"width":"15","height":"12","viewBox":"0 0 15 12"};

module.exports = Email;

Email.default = Email;
